<div *ngIf="loading.value" class="d-flex justify-content-center py-4">
    <mat-spinner></mat-spinner>
</div>
<div class="assignment-boxes" *ngIf="!loading.value && departments.length">
    <fieldset class="assignment-box" *ngFor="let department of departments">
        <legend class="assignment-legend">
            <span class="assignment-name">{{ department.name }}</span>
            <mat-checkbox
                class="select-all-checkbox"
                [checked]="isAllSelected(department.departmentId)"
                [indeterminate]="isIndeterminate(department.departmentId)"
                (change)="onToggleSelectAll(department.departmentId)">
                Select All
            </mat-checkbox>
        </legend>
        <div class="role-list">
            <mat-checkbox
                *ngFor="let role of roles"
                class="role-checkbox"
                [checked]="isChecked(department.departmentId, role.id)"
                (change)="onToggle(department.departmentId, role.id)">
                {{ role.name }}
            </mat-checkbox>
        </div>
    </fieldset>
</div>
<div class="empty-state" *ngIf="!loading.value && !departments.length">
    No cloud departments found.
</div>
